import React from "react";
import skeletonStyles from "../components/Skeletons/Skeletons.module.css";
import classes from "./ManualTimer.module.css";

const ManualTimerSkeleton: React.FC<{ rows?: number }> = ({ rows = 3 }) => {
  return (
    <>
      {[...Array(rows)].map((_, index) => (
        <tr key={index} className={classes.billing_row_skeleton}>
          <td className={classes.billing_table_td}>
            <div
              className={skeletonStyles.skeleton}
              style={{ width: "70%", height: "1.8rem" }}
            ></div>
          </td>
          <td className={classes.billing_table_td}>
            <div
              className={skeletonStyles.skeleton}
              style={{ width: "50%", height: "1.8rem" }}
            ></div>
          </td>
          <td className={classes.billing_table_td}>
            <div className={classes.action_buttons}>
              <div
                className={skeletonStyles.skeleton}
                style={{ width: "5rem", height: "1.8rem", borderRadius: "0.6rem" }}
              ></div>
              <div
                className={skeletonStyles.skeleton}
                style={{ width: "4rem", height: "1.8rem", borderRadius: "0.6rem" }}
              ></div>
            </div>
          </td>
        </tr>
      ))}
    </>
  );
};

export default ManualTimerSkeleton;
